var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSustainable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 401.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "m300.6 111.5.12-.7L407 68.91l-97.61 56.01c16.2 15.61 35.17 23.82 56.66 25.24 44.33 2.92 85.2-16.8 112.55-51.1 5.18-6.49 9.68-13.73 13.64-21.31 4.8-9.18 21.99-40.1 19.52-47.47-3.64-10.79-54.25-18.23-65.81-19.81-60.14-8.24-133.67 1.74-149.99 72.47-.79 3.45-.96 6.98-.68 10.53l-3.39 2.18-3.21-2.34c.6-2.47.92-4.97.86-7.5C288.05 24.83 229.2 4.2 178.3.83c-9.8-.64-52.71-3.08-57.52 5.19-3.29 5.65 5.65 34.01 8.04 42.38 1.98 6.9 4.46 13.63 7.63 19.85 16.72 32.85 47.06 56.01 84.04 61.07 17.93 2.46 34.93-1.1 50.92-11.21l-70.92-62.59 76.57 49.92-.01.54c5.78 20.18 5.14 41.58.08 65.68 9.43-4.27 21.02-4.34 25.52 1.18l.62-.16c-5.15-20.22-9.06-41.71-2.67-61.18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M398.87 223.11c-13.39-24-45.79-31.44-68.52-19.34 10.5-29.11-11.79-35.28-27.7-30.93-7.97-9.81-38.35-1.98-39.23 15.7-29.66-20.02-58.61-9.98-67.47 12.82 6.02 2.38 12.01 5.1 17.96 8.09 12.58 6.31 24.75 13.65 36.73 21.44l44.2 1.07c10.84.84 20.36 5.02 27.42 11.11 9.84 1.08 19.48 1.92 28.7 2.42l47.91-22.38z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M0 196.11h84.3l-3.89 168.01H0V196.11zm99.61 154.44 3.25-139.45 62.72 1.46c26.48 5.39 52.74 20.42 78.94 37.78l48.72 1.14c22.02 1.84 33.05 24.46 11.28 38.65-17.38 12.12-39.9 10.89-62.95 8.28-15.91-1.15-17.1 20.24-.48 20.7 5.76.58 12.07-.62 17.55-.5 28.83.65 52.71-4.31 67.78-26.75l7.7-16.88 73.31-34.25c36.54-11.09 61.42 27.44 34.09 53.2-53.37 36.97-107.94 67.14-163.58 91.24-40.56 23.39-80.52 21.63-119.97-2.8l-58.36-31.82z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainable);
export default __webpack_public_path__ + "static/media/sustainable.01c0ba5bdb12fbe799d3eac9c16bd9ad.svg";
export { ForwardRef as ReactComponent };